module.exports = __webpack_public_path__ + "fonts/Gilroy-900.67c84cd.otf";